module.exports = __webpack_public_path__ + "img/C05TechLiburnianChampion_ua.790d38e3.webp";